import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import get from 'lodash/get';
export default {
  name: 'CoreView',
  props: {
    pageTitle: {
      type: Object,
      required: true
    },
    themes: {
      type: Object,
      required: true
    },
    footerData: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isThemeLoadingDone: false
    };
  },
  metaInfo: function metaInfo() {
    var pageTitle = this.pageTitle;
    var language = this.language;
    return {
      // title: this.$store.state.app.pageTitle[this.language],
      titleTemplate: function titleTemplate() {
        return pageTitle[language];
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['language', 'UiTheme', 'CustomTheme', 'mode'])), {}, {
    footer: function footer() {
      if (get(this.$route, 'meta.hideLayout') || this.footerData.hide) {
        return false;
      }

      return this.$route.name !== 'Maps' && this.$route.path !== '/error';
    },
    fillHeight: function fillHeight() {
      return this.$route.path === '/error' ? 'fill-height' : '';
    },
    id: function id() {
      if (get(this.$route, 'meta.hideLayout') && get(this.$route, 'meta.fullHeight') === false) {
        return '';
      }

      if (get(this.$route, 'meta.hideLayout') && get(this.$route, 'meta.fullHeight') === true) {
        return 'full-height-view';
      }

      return this.$route.path !== '/login' && this.$route.path !== '/error' && this.$route.path !== '/reset-password' && this.$route.path !== '/change-password' && this.$route.path !== '/oauth' && this.$route.path !== '/' ? 'core-view' : '';
    },
    backgroundStyle: function backgroundStyle() {
      var isPublicDashboard = this.$route.path.startsWith('/public');
      var isFavoritesPage = this.$route.path.startsWith('/home');
      var useCustomBackground = this.$store.state.app.useCustomBackground; // public dashboard will always be white

      if (isPublicDashboard) {
        return 'background-color: #fff;';
      }

      var mode = this.UiTheme ? 'dark' : 'light'; // if useCustomBackground is set and its the favorites page then use the custom theme

      if (isFavoritesPage && useCustomBackground) {
        var gradient = mode === 'dark' ? 'linear-gradient(rgba(50, 50, 50, 0.98), rgba(50, 50, 50, 0.85))' : 'linear-gradient(rgba(240, 240, 240, 0.98), rgba(240, 240, 240, 0.8))';

        if (this.themes) {
          return "background-image: ".concat(gradient, ", url(").concat(this.themes[mode].background, "); background-size: cover;");
        } else {
          return "background-image: ".concat(gradient, "; background-size: cover;");
        }
      } // otherwise use default colors for the theme mode


      return "background-color: ".concat(mode === 'light' ? '#E5E5E5' : '#2d2d2d', ";");
    }
  })
};